import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0afe376f")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, " % ", -1)
_popScopeId()

import { computed, watch, reactive } from 'vue';
import useNumbers from '@/composables/useNumbers';
import useUserSettings from '@/composables/useUserSettings';
import { bnum } from '@/lib/utils';


export default _defineComponent({
  setup(__props) {

const FIXED_OPTIONS = ['0.005', '0.01', '0.02'];

/**
 * COMPOSABLES
 */
const { fNum } = useNumbers();
const { slippage, setSlippage } = useUserSettings();

/**
 * STATE
 */
const state = reactive({
  fixedSlippage: '',
  customSlippage: '',
  isCustomInput: false
});

const options = FIXED_OPTIONS.map(option => {
  return {
    label: fNum(option, null, { format: '0.0%' }),
    value: option
  };
});

/**
 * COMPUTED
 */
const isFixedSlippage = computed(() => {
  return FIXED_OPTIONS.includes(slippage.value);
});

const customInputClasses = computed(() => ({
  'border border-gold-200 text-white':
    !isFixedSlippage.value || state.isCustomInput,
  'border dark:border-gray-900': isFixedSlippage.value && !state.isCustomInput
}));

/**
 * METHODS
 */
function onFixedInput(val: string): void {
  state.isCustomInput = false;
  state.customSlippage = '';
  setSlippage(val);
}

function onCustomInput(val: string): void {
  state.isCustomInput = true;
  val = bnum(val)
    .div(100)
    .toString();
  setSlippage(val);
}

/**
 * WATCHERS
 */
watch(
  slippage,
  newSlippage => {
    if (isFixedSlippage.value && !state.isCustomInput) {
      state.fixedSlippage = newSlippage;
      state.customSlippage = '';
    } else {
      state.customSlippage = bnum(newSlippage)
        .times(100)
        .toString();
      state.fixedSlippage = '';
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_BalBtnGroup = _resolveComponent("BalBtnGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BalBtnGroup, {
      options: _unref(options),
      modelValue: _unref(state).fixedSlippage,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (_unref(state).fixedSlippage = $event)),
        onFixedInput
      ]
    }, null, 8, ["options", "modelValue"]),
    _createElementVNode("div", {
      class: _normalizeClass(['custom-input', _unref(customInputClasses)])
    }, [
      _withDirectives(_createElementVNode("input", {
        class: "w-12 text-right bg-transparent",
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => (_unref(state).customSlippage = $event)),
          onCustomInput
        ],
        placeholder: "0.1",
        type: "number",
        step: "any",
        min: "0"
      }, null, 512), [
        [_vModelText, _unref(state).customSlippage]
      ]),
      _hoisted_2
    ], 2)
  ]))
}
}

})